import { ref } from 'vue'
import apiClient from '@/api/client'
import { INSTITUTIONS } from '@/api/endpoints'
import type { Institution } from '@/types/institution'

export function useInstitutions() {
  const institutions = ref<Institution[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetchInstitutions() {
    loading.value = true
    error.value = null
    try {
      const response = await apiClient.get(INSTITUTIONS.LIST, {
        params: {
          page_size: 1000
        }
      })
      institutions.value = response.data.items
    } catch (err: any) {
      console.error('Error fetching institutions:', err)
      error.value = err.response?.data?.message || 'Failed to fetch institutions'
    } finally {
      loading.value = false
    }
  }

  return {
    institutions,
    loading,
    error,
    fetchInstitutions
  }
} 